import path from 'path'
import { APIError, Forbidden, type PayloadHandler } from 'payload'
import { ClientUploadsAccess } from '@payloadcms/plugin-cloud-storage/types'
import { getFetchURL } from '../utils.js'
import { wlodevS3Path } from '../config.js'

type Args = {
    access?: ClientUploadsAccess
}

const defaultAccess: Args['access'] = ({ req }) => !!req.user

export const getGenerateSignedURLHandler = ({
    access = defaultAccess,
}: Args): PayloadHandler => {
    return async req => {
        if (!req.json) {
            throw new APIError(
                'Content-Type expected to be application/json',
                400
            )
        }

        const { collectionSlug, filename, mimeType } = await req.json()
        if (!(await access({ collectionSlug, req }))) {
            throw new Forbidden()
        }

        try {
            const url = getFetchURL(req.headers, path.posix.join(wlodevS3Path))
            url.searchParams.set('key', filename)
            url.searchParams.set('collection', collectionSlug)

            return Response.json({ url })
        } catch (error) {
            throw new APIError('Invalid wlodev upload url', 400)
        }
    }
}
